import Act from "../actions";

const initState = {};

const homeReducer = (state = initState, action) => {
  switch (action.type) {
    case Act.TEST:
      return { ...state };
    default:
      return state;
  }
};
export default homeReducer;
